var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "plus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 2.66667C8.36754 2.66667 8.66602 2.96514 8.66602 3.33333V7.33333H12.666C13.0342 7.33333 13.3327 7.63181 13.3327 8C13.3327 8.36819 13.0342 8.66667 12.666 8.66667H8.66602V12.6667C8.66602 13.0349 8.36754 13.3333 7.99935 13.3333C7.63116 13.3333 7.33268 13.0349 7.33268 12.6667V8.66667H3.33268C2.96449 8.66667 2.66602 8.36819 2.66602 8C2.66602 7.63181 2.96449 7.33333 3.33268 7.33333L7.33268 7.33333L7.33268 3.33333C7.33268 2.96514 7.63116 2.66667 7.99935 2.66667Z",
    fill: "white",
    fillOpacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.56b5bf57106a1918d94bfdafcb835c93.svg";
export { ForwardRef as ReactComponent };